import React from 'react'
import { createGlobalStyle } from 'styled-components'
import FontGlobalStyle from './font.style'
import CustomFontGlobalStyle from './customFont.style'

const FontStyle = createGlobalStyle`
  * {
    font-family: ${props => props.theme.typographyBodyText};
  }
`

const FontContainer = React.memo(() => (
  <React.Fragment>
    <FontStyle />
    <FontGlobalStyle />
    <CustomFontGlobalStyle />
  </React.Fragment>
))

export default FontContainer
